import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryString } from "@/utils/query-string";
import { AxiosInstance } from "axios";

interface SBEProps {
  Id: number;
}

let entityStatusApiPromise: Promise<AxiosInstance> | null = null;

const getEntityStatusApi = () => {
  if (entityStatusApiPromise) return entityStatusApiPromise;
  entityStatusApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return entityStatusApiPromise;
};

export const getStatusByEntity = async (props: SBEProps) => {
  const api = await getEntityStatusApi();
  if (!api) return null;
  const response = await api.get(
    `/Soporte/GetEstadosByIdEntidad?${objectToQueryString(props)}`,
  );

  return response.data;
};
